import script from "./WoononSubtotalMobileWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononSubtotalMobileWidget.vue?vue&type=script&lang=ts&setup=true"

import "./WoononSubtotalMobileWidget.vue?vue&type=style&index=0&id=a183a79a&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a183a79a"]])

export default __exports__